<template>
  <div>
    <Header>
      Kontakty
      <template v-if="user.can_manage_contacts" #right>
        <b-button variant="primary" size="sm" @click="$inertia.visit(route('contacts.create'))">
          <b-icon icon="plus"/>
        </b-button>
      </template>
    </Header>

    <b-card no-body class="mb-3">
      <b-card-body class="p-2 table-primary">
        <b-input
          v-model="search"
          type="search"
          placeholder="Szukaj..."
          debounce="500"
        />
      </b-card-body>
    </b-card>

    <b-table-simple :responsive="true" striped :small="isMobile" class="table-vcenter">
      <b-thead head-variant="light">
        <b-tr>
          <b-th>Nazwa</b-th>
          <b-th>Telefon</b-th>
          <b-th>Email</b-th>
          <b-th class="text-right">#</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr v-for="contact in contacts" :key="contact.id">
          <b-td nowrap>
            <div class="py-3">
              {{ contact.name }}
            </div>
          </b-td>
          <b-td nowrap>
            <b-link :href="`tel:${contact.phone_number}`" class="text-dark">
              {{ contact.phone_number }}
            </b-link>
          </b-td>
          <b-td nowrap>
            <span v-if="contact.email">
              <b-icon icon="envelope-fill" title="Email dostępny"/>
            </span>
          </b-td>
          <b-td class="text-right" nowrap>
            <inertia-link
              v-if="user.can_manage_contacts"
              :href="route('contacts.edit', contact.id)"
              as="b-button"
              variant="outline-primary"
              size="sm"
            >
              <b-icon icon="pencil-fill"/>
            </inertia-link>
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script>
import Layout from '@/Layouts/Default'
import Header from '@/Layouts/Components/Header'

export default {
  layout: Layout,
  components: {
    Header,
  },
  props: {
    contacts: Array,
    filters: Object,
  },
  data() {
    return {
      searching: false,
      search: '',
    }
  },
  watch: {
    'search': function (val) {
      this.doSearch()
    }
  },
  computed: {
    user() {
      return this.$page.props.auth.user
    },
  },
  methods: {
    doSearch() {
      this.$inertia.get(this.route('contacts.index'), {search: this.search}, {
        replace: true,
        preserveState: true,
        onFinish: () => this.searching = false,
      })
    },
  },
}
</script>
